import { INotaryDetailsData } from '../../../../../../types/signingAppointment/INotaryDetailsData';
import { useListSigningAppointmentsQuery } from '../../../../../../API/order/signingAppointment/SigningAppointmentAPI';
import { useMemo } from 'react';
import { ISigningAppointmentResponse } from '../../../../../../types/signingAppointment/ISigningAppointmentResponse';
import { eConsumerTypes } from '../../../../../../types/order/consumer/eConsumerTypes';
import { useSelectCurrentOrderId } from '../../../../../../selectors/order/selectCurrentOrder';

export const useFindNotary = (): INotaryDetailsData | undefined => {
  const orderId = useSelectCurrentOrderId()!;
  const { data: signingAppointments = [] } = useListSigningAppointmentsQuery({ orderId });
  return useMemo(() => {
    return (
      signingAppointments.find((data: ISigningAppointmentResponse) => data.ownerType === eConsumerTypes.borrower)
        ?.notary ??
      signingAppointments.find((data: ISigningAppointmentResponse) => data.ownerType === eConsumerTypes.seller)?.notary
    );
  }, [signingAppointments]);
};
